<script>

    import { toast } from 'bulma-toast'
    import { shipmentStore } from '../stores'

    import ShipmentsService from '../$services/shipments.service'

    import Form from '../$components/form.svelte'
    import Select from '../$components/select.svelte'
    import Input from '../$components/input.text.svelte'
    import Date from '../$components/date.svelte'
    import Save from '../$components/button.save.svelte'

    const clasifications = [
        { text: 'Entregado', value: 'Entregado', motives: null },
        { text: 'Recolectado', value: 'Recolectado', motives: null },
        { text: 'En ruta de entrega', value: 'En ruta de entrega', motives: null },
        { text: 'Dirección incorrecta', value: 'Dirección incorrecta', motives: null },
        {
            text: 'Intento de entrega',
            value: 'Intento de entrega',
            motives: [
                'No se encuentra nadie en el domicilio',
                'No conocen al destinatario',
                'Reprogramación de entrega a petición del cliente',
                'Empresa y/o persona de vacaciones / dia festivo',
                'Domicilio cerrado',
                'Titular cambio de domicilio',
                'La empresa desapareció',
                'Domicilio Deshabitado',
            ],
        },
        {
            text: 'Devolución',
            value: 'Devolución',
            motives: [
                'Guía rechazada por destinatario',
                'Cliente canceló compra',
            ],
        },
        {
            text: 'Dirección insuficiente',
            value: 'Dirección insuficiente',
            motives: [
                'Falta indicar edificio',
                'Falta indicar lote / manzana',
                'Falta número exterior',
                'Falta número interior',
                'No se localiza calle',
                'No se localiza número',
            ],
        },
        {
            text: 'Incidencia operativa',
            value: 'Incidencia operativa',
            motives: [
                'Mal sorteado',
                'Demora, bloqueo, manifestación',
                'Reprogramación de entrega',
                'Problemas de entrega por clima',
                'Demora por falla mecánica',
                'Siniestro',
                'Incidente en ruta',
                'Daño de empaque',
                'Robo a ruta',
            ],
        },
    ]

    const clasificationOptions = clasifications.map(({ text, value }) => ({ text, value }))

    let data = {}
    let loading = false
    let evidenceFile = null
    let evidenceFiles

    $: evidenceFile = evidenceFiles?.[0] ?? null

    $: currentClassification = clasifications.find((c) => c.value === data.name)

    $: detailOptions = currentClassification?.motives?.map((m) => ({ value: m, text: m })) ?? []

    $: useManualDetails = !!currentClassification && currentClassification.motives === null

    function onClassificationSelect() {
        const current = clasifications.find((c) => c.value === data.name)
        if (!current) return
        if (current.value !== 'Entregado') {
            evidenceFile = null
            evidenceFiles = null
        }
        if (current.motives === null) {
            data.details = ''
        } else {
            const ok = current.motives.some((m) => m === data.details)
            if (!ok) data.details = current.motives[0]
        }
    }

    function fileToBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = () => {
                const result = String(reader.result || '')
                resolve(result.includes(',') ? result.split(',')[1] : result)
            }
            reader.onerror = reject
            reader.readAsDataURL(file)
        })
    }

    async function updateShipmentTracking() {

        loading = true

        if (data.name === 'Entregado' && evidenceFile) {
            const base64 = await fileToBase64(evidenceFile)
            const evidenceResp = await ShipmentsService.updateShipmentEvidence($shipmentStore._id, { base64 })
            if (!evidenceResp.success) {
                loading = false
                return toast({message: evidenceResp.error.message, type: 'is-danger'})
            }
            shipmentStore.set(evidenceResp.data)
        }

        const resp = await ShipmentsService.updateShipmentTracking($shipmentStore._id, {tracking: data})
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        shipmentStore.set(resp.data)
        toast({message: 'Información actualizada', type: 'is-success'})
    }
</script>

<Form on:submit={updateShipmentTracking} {loading} >
    
    <div class="columns">
        <div class="column">
            <Select bind:value={ data.name }
                label="Clasificación del estatus"
                text="Selecciona la clasificación"
                options={ clasificationOptions }
                on:select={ onClassificationSelect }
            />
        </div>
    </div>
    {#if data.name}
        <div class="columns">
            <div class="column">
                {#if useManualDetails}
                    <Input bind:value={ data.details }
                        label="Detalles del estatus"
                        placeholder="Ingrese los detalles del tracking"
                    />
                {:else}
                    <Select bind:value={ data.details }
                        label="Detalles del estatus"
                        text="Selecciona el motivo"
                        options={ detailOptions }
                        required={ detailOptions.length > 0 }
                    />
                {/if}
            </div>
        </div>
    {/if}
    <div class="columns">
        <div class="column">
            <Date bind:value={ data.created } label="Fecha del tracking" />
        </div>
    </div>
    {#if data.name === 'Entregado'}
        <div class="columns">
            <div class="column">
                <label class="label">Evidencia de entrega (opcional)</label>
                <div class="file has-name is-fullwidth">
                    <label class="file-label">
                        <input bind:files={evidenceFiles} class="file-input" type="file" accept="image/*">
                        <span class="file-cta">
                            <span class="file-icon"><i class="fas fa-upload"></i></span>
                            <span class="file-label">Selecciona</span>
                        </span>
                        <span class="file-name">{evidenceFile ? evidenceFile.name : 'No se ha seleccionado una imagen'}</span>
                    </label>
                </div>
            </div>
        </div>
    {/if}
    <br>
    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        <Save />
    </div>
</Form>